import React, { useState, useEffect } from "react";
import ReportsSubmission from "./ReportsSubmission";
import RenderChecklist from "./RenderChecklist";
import { useUser } from "../Contexts/UserContext";
import UploadPdfReport from "./UploadPdfReport";
import ViewPdf from "./ViewPdf";
//import { API_URL, getTodayDate } from "./config"; // Assuming API_URL and getTodayDate are defined
const API_URL = process.env.REACT_APP_DOMAIN_API_URL;
const FacilityReportSubmissionPage = () => {
  const [isVisible, setIsVisible] = useState(true);
  const [formData, setFormData] = useState([]); // Initialize as an empty array
  const [selectedData, setSelectedData] = useState({
    remark: "",
    unitCode: "",
    empCode: "",
    reportObj: null,
    reportId: "0",
    dateValue: "",
  });
  const [isLoading, setIsLoading] = useState(false);

  const [tableData, setTableData] = useState([]);
  const [reportsDD, setReportsDD] = useState([]);
  const { user } = useUser();
  const { ClientId } = user;

  useEffect(() => {
    const fetchInitData = async () => {
      try {
        const response = await fetch(
          `${API_URL}/facility/GetClientReportList/${ClientId}`
        );
        const result = await response.json();
        if (result.success) {
          setReportsDD(result.data || []);
        }
      } catch (error) {
        console.error("Error fetching report list:", error);
      }
    };

    fetchInitData();
  }, [ClientId]); // Dependency array to avoid redundant calls

  const handleFetchReports = async () => {
    try {
      setIsLoading(true);

      // Ensure reportObj exists before setting state
      if (!selectedData.reportObj?.ID) {
        alert("Report ID is missing.");
        setIsLoading(false);
        return;
      }

      const reportId = selectedData.reportObj.ID; // Store it in a variable
      setSelectedData((prev) => ({ ...prev, reportId }));

      const response = await fetch(
        `${API_URL}/facility/getSubchecklist/${reportId}`
      );

      const result = await response.json();

      if (result.success && Array.isArray(result.data)) {
        setTableData(result.data);
        setFormData(
          result.data.map((obj) => ({
            checkListId: obj.checklistid,
            checkListName: obj.MasterName,
            image: "NA",
            status: "0",
          }))
        );
      } else {
        setTableData([]);
        setFormData([]);
        alert("No data found.");
      }
    } catch (error) {
      console.error("Error fetching reports:", error);
      alert("An error occurred while fetching reports.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleStoreData = (idx, field, value) => {
    setFormData((prevData) =>
      prevData.map((item, i) =>
        i === idx ? { ...item, [field]: value } : item
      )
    );
  };
  function convertDateTime(inputDateTime) {
    const date = new Date(inputDateTime);

    // Extract individual components
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    const milliseconds = String(date.getMilliseconds()).padStart(3, "0");

    // Format the output
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${milliseconds}`;
  }
  const handleSave = async () => {
    // Validation: Ensure all required fields are filled
    if (
      !selectedData.empCode ||
      !selectedData.unitCode ||
      !selectedData.reportObj?.ID ||
      !selectedData.dateValue
    ) {
      alert("Employee Code, Unit Code, and Report Type are required.");
      return;
    }

    // Validation: Ensure all checklist items are properly filled
    for (let item of formData) {
      if (item.status == "1" && item.image === "NA") {
        alert(
          "Please fill out all checklist fields and upload an image where required."
        );
        return;
      }
    }
    const dateTime = convertDateTime(selectedData.dateValue);
    try {
      const response = await fetch(
        `https://www.apsgroupapp.com/ExpressAPI/postChecklistData`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            qrValue: `xyz+${dateTime}`,
            empCode: selectedData.empCode,
            siteCode: selectedData.unitCode,
            chkPointId: selectedData.reportObj?.ID,
            remarks: selectedData.remark,
            data: formData,
          }),
        }
      );

      const result = await response.json();
      if (result.success) {
        alert("Data Saved Successfully :)");
      } else {
        alert("Failed to save data: " + result.message);
      }
    } catch (error) {
      console.error("Error saving data:", error);
      alert("An error occurred while saving.");
    }
  };

  return (
    <div style={{ padding: "2rem 4rem" }}>
      <ReportsSubmission
        title="Submit Facility Reports"
        selectedData={selectedData}
        setSelectedData={setSelectedData}
        handleFetchReports={handleFetchReports}
        reportTypeList={reportsDD}
      />
      {isLoading ? (
        <span>Loading...</span>
      ) : selectedData.reportId === "0" ? (
        <span>No Data To Show</span>
      ) : (
        <RenderChecklist
          data={tableData}
          handleSave={handleSave}
          handleStoreData={handleStoreData}
          formData={formData}
          selectedData={selectedData}
          setSelectedData={setSelectedData}
        />
      )}
    </div>
  );
};

export default FacilityReportSubmissionPage;
